export default {
  type: 'blockquote',
  title: `Blockquote (legacy)`,
  icon: `comment`,
  template: (config) => `
      <blockquote
        contenteditablebind
        contenteditable="true"
        feature-obj="feature"
        org-index="orgIndex"
        data-index="${config.index}"
        ng-model="feature.content"
        value="{{feature.content}}"
        ng-bind-html="feature.content"
        data-xplaceholder="Type your quote here"
        ng-attr-data-placeholder="{{(!feature.content.trim().length && 'Type your quote here.') || '' }}">
      </blockquote>
    `,
  onPaste: function (elem) {
    return {
      type: 'blockquote',
      content: elem.html(),
    }
  },
  initialInflation: function () {
    return {
      type: 'blockquote',
      content: '',
    }
  },
  convertable: true,
}
